<template>
  <div class="section complementares">
    <el-card class="info-box" shadow="never">
      <div class="info-content">
        <div class="icon-atencao">
          <div>
            <img src="@/assets/info.svg" alt="Info" />
          </div>
          <div>Atenção!</div>
        </div>
        <div class="info-text">
          <span class="esportiva"
            >Modalidade esportiva: Pesca e solta o peixe</span
          >
          <span class="separator">|</span>
          <span class="recreativa">Modalidade recreativa: Leva o peixe</span>
        </div>
      </div>
    </el-card>
    <p>Selecione qual a modalidade da pesca</p>
    <el-radio-group
      v-model="localModel.modalidadePesca"
      class="radio-group"
      @change="emitUpdate"
    >
      <el-radio
        v-for="modalidade in listaOpcoes.modalidadesPesca"
        :key="modalidade.cod"
        :label="modalidade.cod"
      >
        {{ modalidade.descricao_pt }}
      </el-radio>
    </el-radio-group>
    <p class="info2 total-price">
      Valor total a pagar:
      <strong>R$ {{ valorTotal }}</strong>
    </p>
    <p class="info2 small-text">
      Valor referente a uma carteira com validade de 02 anos.
    </p>

    <p>
      Em média quantos dias por ano costuma pescar?
      <span style="color: red;">*</span>
    </p>
    <el-input-number
      v-model="localModel.diasPescaPorAno"
      :min="0"
      :max="365"
      class="input-number"
      @change="emitUpdate"
      :class="{
        'campo-com-erro': validarPasso1 && verificaCampoErro('diasPescaPorAno')
      }"
    />
    <span
      v-if="validarPasso1 && verificaCampoErro('diasPescaPorAno')"
      class="mensagem-erro"
    >
      Campo obrigatório
    </span>

    <p>Qual peixe você costuma pescar? <span style="color: red;">*</span></p>
    <el-select
      v-model="localModel.peixeMaisPescado"
      placeholder="Selecione"
      class="select"
      @change="emitUpdate"
      multiple
      :class="{
        'campo-com-erro':
          validarPasso1 && verificaCampoErro('peixesMaisPescados')
      }"
    >
      <el-option
        v-for="peixe in listaOpcoes.peixesMaisPescados"
        :key="peixe.cod"
        :label="peixe.descricao_pt"
        :value="peixe.cod"
      >
        {{ peixe.descricao_pt }}
      </el-option>
    </el-select>
    <span
      v-if="validarPasso1 && verificaCampoErro('peixesMaisPescados')"
      class="mensagem-erro"
    >
      Campo obrigatório
    </span>

    <p>
      Qual o tipo de material / equipamento você utiliza?
      <span style="color: red;">*</span>
    </p>
    <el-checkbox-group
      v-model="localModel.equipamentos"
      class="checkbox-group"
      @change="emitUpdate"
      :class="{
        'campo-com-erro': validarPasso1 && verificaCampoErro('equipamentos')
      }"
    >
      <el-checkbox
        v-for="material in listaOpcoes.equipamentos"
        :key="material.cod"
        :label="material.descricao_pt"
      >
        {{ material.descricao_pt }}
      </el-checkbox>
    </el-checkbox-group>
    <span
      v-if="validarPasso1 && verificaCampoErro('equipamentos')"
      class="mensagem-erro"
    >
      Campo obrigatório
    </span>
  </div>
</template>

<script>
import { calcularPreco } from "@/utils/calculoPreco";
export default {
  name: "InformacoesComplementares",
  props: {
    modelValue: Object,
    listaOpcoes: Object,
    verificaCampoErro: Function,
    validarPasso1: Boolean
  },
  data() {
    return {
      localModel: { ...this.modelValue }
    };
  },
  computed: {
    valorTotal() {
      return calcularPreco(this.localModel.modalidadePesca);
    }
  },
  watch: {
    modelValue: {
      deep: true,
      handler(newValue) {
        this.localModel = { ...newValue };
      }
    }
  },
  methods: {
    emitUpdate() {
      this.$emit("update:modelValue", this.localModel);
    }
  }
};
</script>

<style scoped>
/* Estilos específicos para o componente */
.section {
  margin-bottom: 20px;
  padding: 10px;
  border-radius: 8px;
}

.info-box {
  background-color: #dde9ed !important;
  border-radius: 4px;
  padding: 10px 16px;
  width: 600px;
  float: right;
}

.info-content {
  display: flex;
  flex-direction: column;
}

.icon-atencao {
  display: flex;
  align-items: center;
  gap: 10px;
  align-self: start;
}

.info-text {
  display: flex;
  flex-wrap: wrap;
  font-style: italic;
  color: #2c3e50;
  font-size: 14px;
  font-weight: 300;
}

.small-text {
  font-size: 12px;
  margin-bottom: 20px;
}

.separator {
  margin: 0 8px;
  color: #999;
}

.radio-group,
.checkbox-group,
.select,
.input-number {
  margin-bottom: 15px;
}

.total-price {
  font-style: italic;
}

.campo-com-erro :deep(.el-input__inner) {
  border-color: red !important;
}

.mensagem-erro {
  color: red;
  font-style: italic;
  font-size: 12px;
  margin-top: -10px;
  margin-bottom: 10px;
  display: block;
}
</style>
